


















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Avatar extends Vue {
  public $refs!: {
    fileUpload: HTMLFormElement;
  };

  @Prop({ default: null })
  public src!: string;

  @Prop({ default: null })
  public name!: string;

  @Prop({ default: "image" })
  public icon!: string;

  @Prop({ default: false })
  public clickable!: boolean;

  @Prop({ default: false })
  public uploadable!: boolean;

  @Prop({ default: 100 })
  public size!: number;

  @Prop({ default: false })
  public loading!: boolean;

  public onClick() {
    if (this.loading || this.uploadable) {
      return;
    }

    if (this.clickable) {
      this.$emit("click");
    }
    return;
  }

  public onFileChanged(event) {
    this.$emit("file-changed", this.$_.get(event, "target.files[0]", {}));
    this.$refs.fileUpload.value = "";
  }

  public onDelete() {
    this.$emit("file-delete");
  }
}
